// src/components/icons/FeedauraIcon.tsx
import React from 'react';
import Logo from '../Logo';
import { IconProps } from '../../../../utils/types';

export const FeedauraIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'white',
  animated = false,
}) => (
  <div className={animated ? 'animated-icon' : undefined} style={{ lineHeight: 0 }}>
    {/* Logo already accepts size & color */}
    <Logo size={size} color={color} />
  </div>
);
